import { render, staticRenderFns } from "./DetailNotFound.vue?vue&type=template&id=00681988&scoped=true&"
import script from "./DetailNotFound.vue?vue&type=script&lang=js&"
export * from "./DetailNotFound.vue?vue&type=script&lang=js&"
import style0 from "./DetailNotFound.vue?vue&type=style&index=0&id=00681988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00681988",
  null
  
)

export default component.exports